export {data};

import API_URL from '../../includes/api.js';
import {resolveTenantData} from '../../tenant/site-configs.js';
import {fetchApiJson, refererHeaders} from '../../includes/server-fetch.js';

// Mirrors Playlists.jsx's mount-time fetch so the grid is populated before hydration.
//
// +data.shared.js is NOT cumulative in Vike — this page-level file replaces the root
// one, so it must resolve+spread tenant data itself or lose messages/faq/about.
async function data(pageContext) {
    const tenantData = resolveTenantData(pageContext);

    // Playlists.jsx's client-side fetch still runs after hydration when
    // this is null and will retry, so a failed fetch must stay null, not [].
    const result = await fetchApiJson(`${API_URL}/playlist/all`, refererHeaders(pageContext), pageContext);
    return {...tenantData, playlists: result.ok ? (result.data ?? []) : null};
}
